export default __webpack_public_path__ + "static/media/program_intro_8.666e35a0.png";